import { useState } from "react";
import { sendContact } from "@/lib/api";
import { Overline, PrimaryButton } from "@/components/site/Primitives";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await sendContact(form);
      setDone(true);
      toast.success(res.message);
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setLoading(false); }
  };

  const inputCls = "w-full bg-brand-warm-white border border-brand-linen px-5 py-4 font-body text-brand-charcoal focus:outline-none focus:border-brand-gold transition-colors";

  return (
    <div data-testid="contact-page">
      <section className="max-w-2xl mx-auto px-6 pt-24 pb-12 text-center">
        <Overline>Do write to me</Overline>
        <h1 className="text-5xl sm:text-6xl font-light mt-5 mb-5 leading-none">Contact</h1>
        <p className="font-body text-brand-body text-lg leading-relaxed">
          Whether it's a question, a kind word, or a recipe of your own you'd care to share — I should love to hear from you.
        </p>
      </section>
      <section className="max-w-2xl mx-auto px-6 pb-24">
        {done ? (
          <p className="font-serif text-3xl text-center text-brand-olive py-16" data-testid="contact-success">Thank you. Your letter is on its way, and I shall reply soon.</p>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <input required placeholder="Your name" value={form.name} onChange={set("name")} data-testid="contact-name" className={inputCls} />
            <input required type="email" placeholder="Your email" value={form.email} onChange={set("email")} data-testid="contact-email" className={inputCls} />
            <input placeholder="Subject" value={form.subject} onChange={set("subject")} data-testid="contact-subject" className={inputCls} />
            <textarea required rows={6} placeholder="Your message" value={form.message} onChange={set("message")} data-testid="contact-message" className={inputCls} />
            <PrimaryButton type="submit" testid="contact-submit" disabled={loading}>{loading ? "Sending…" : "Send your letter"}</PrimaryButton>
          </form>
        )}
      </section>
    </div>
  );
}
